export const findPageLabel = (reachTextInput, pageLabel) =>
  reachTextInput.find(({ label }) => label === pageLabel);

export const getReachText = input =>
  input.filter(i => i.__typename.includes('PageBodyReach_text'));
